module.exports = __webpack_public_path__ + "static/img/gif1.b867961.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif1.gif
// module id = FtQO
// module chunks = 2